import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserDeliveryTerms {
  constructor($scope, $rootScope, UserDeliveryTermService, GeoService) {
    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.$watch('seller_term.country_id', function() {
      if ($scope.seller_term) {
        if ($scope.seller_term.country_id) {
          GeoService.get_cities($scope.seller_term.country_id).then(function(data) {
            $scope.seller_term_cities = data.cities;
            if (!_.findWhere(data.cities, {id: $scope.seller_term.city_id}))
              $scope.seller_term.city_id = null;
          });
        }
      }
    });

    $scope.edit_delivery_terms = function(key, terms) {
      $scope.dialog_term = {
        key: key,
        delivery_term_id: terms[0].delivery_term_id,
        terms: angular.copy(terms)
      };
      $scope.open_dialog('user_delivery_term_dialog');
    };

    $scope.add_delivery_term = function(terms) {
      var term = angular.copy(window.delivery_term);
      term.delivery_term_id = $scope.dialog_term.delivery_term_id;
      terms.push(term);
    };

    $scope.save_delivery_term = function(term) {
      $scope.updating_term = true;
      UserDeliveryTermService.save(term).then(function(data) {
        if (data.success) {
          $scope.updating_term = false;
          $.fancybox.close();
          $scope.user_delivery_terms = data.user_delivery_terms;
          $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 2 : 3, [{
            type: 'counter',
            value: $scope.user_delivery_terms.length
          }]]);
          if ($scope.role == 1)
            $scope.seller_term = $scope.user_delivery_terms[0];
        }
      });
    };

    $scope.delete_delivery_term = function(terms, index) {
      terms.splice(index, 1);
    };

    $scope.save_delivery_terms = function(user_id, terms) {
      $scope.updating_term = true;
      terms = _.map(terms, function(term) {
        return _.omit(term, 'cities');
      });
      UserDeliveryTermService.save_all(user_id, $scope.dialog_term.delivery_term_id, terms).then(function(data) {
        if (data.success) {
          $scope.updating_term = false;
          $.fancybox.close();
          $scope.user_delivery_terms = _.groupBy(data.user_delivery_terms, 'delivery_term_name');
          $scope.set_delivery_terms_count(data.user_delivery_terms);
        }
      });
    };

    $scope.set_delivery_terms_count = function(user_delivery_terms) {
      var count = 0;
      angular.forEach(user_delivery_terms, function(term) {
        if (term.country_id)
          count++;
      });
      $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 2 : 3, [{
        type: 'counter',
        value: count
      }]]);
    };

    $scope.get_countries_str = function(terms) {
      var countries = _.uniq(_.map(terms, function(t) {
        return {
          country: t.country_name,
          country_id: t.country_id
        };
      }));
      var result = [];
      angular.forEach(countries, function(c) {
        if (c.country && c.country_id)
          result.push(c.country + ' (' + c.country_id + ')');
      });
      return result.join(', ');
    };

    $scope.get_cities_str = function(terms) {
      var cities = _.uniq(_.map(terms, function(t) {
        return {
          city: t.city_name,
          city_id: t.city_id
        };
      }));
      var result = [];
      angular.forEach(cities, function(c) {
        if (c.city && c.city_id)
          result.push(c.city + ' (' + c.city_id + ')');
      });
      return result.join(', ');
    };

    $scope.init = function() {
      $scope.delivery_terms = window.delivery_terms;
      $scope.countries = window.countries;
      $scope.user_id = window.user_id;
      $scope.role = window.role;
      if ($scope.role == 0) {
        $scope.user_delivery_terms = _.groupBy(window.user_delivery_terms, 'delivery_term_name');
      } else {
        $scope.user_delivery_terms = window.user_delivery_terms;
        $scope.seller_term = $scope.user_delivery_terms.length > 0 ? $scope.user_delivery_terms[0] : angular.copy(window.delivery_term);
      }
      $scope._ = _;
    };

    $scope.init();

  }
}

UserDeliveryTerms.$inject = ['$scope', '$rootScope', 'UserDeliveryTermService', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-delivery-terms.ctrl.js